import { TrainingStep } from "../../components/common/TrainingGuide";

const attendanceSteps: TrainingStep[] = [
  {
    title: "Attendance & Employee Management",
    description:
      "This module tracks employee check-in/out times, calculates KPIs, and shows attendance rates. It covers three employees: Hafiz (target 78%), Nadir (target 50%), Mehriban (target 66%).",
    tip: "Abdolmadjid (owner) uses a different KPI mode — hours-based rather than attendance percentage.",
  },
  {
    title: "Check-In and Check-Out",
    description:
      "Employees check in by hitting the button on their mobile dashboard. Each check-in creates an AttendanceLog record with a timestamp. There are two shifts: morning and evening.",
    tip: "If an employee forgets to check out, their KPI for that day is calculated as 0% for that shift pair.",
  },
  {
    title: "Reading KPI Cards",
    description:
      "Each employee card shows attendance_rate (actual vs scheduled minutes), bonus_percentage, and effective_rate. Green = on target, amber = slightly below, red = significantly below target.",
    tip: "KPIs are recomputed nightly. For an immediate refresh, change the period selector (7d / 14d / 30d).",
  },
  {
    title: "Late Arrivals & Overtime",
    description:
      "The system flags late check-ins (more than 15 minutes after scheduled start) and tracks overtime. Overtime is capped at 120% effective rate to avoid inflating scores.",
    tip: "Review the overtime column weekly — consistent overtime may indicate understaffing.",
  },
  {
    title: "Mobile Dashboard",
    description:
      "Employees on mobile see a stripped-down dashboard: just their own KPI, a big check-in button, and today's schedule. It auto-detects mobile devices (screen width ≤ 768px or mobile UA).",
    tip: "The mobile dashboard sends a ping every 10 minutes so you can see online/idle/offline status in real time.",
  },
];

export default attendanceSteps;
